import BootstrapButton from "@/components/form/BootstrapButton"
import { showError } from "@/composition/useLoading"
import usePopups from "@/stores/popupsStore"
import { ref, shallowRef } from "vue"
import { Alert, ModalTitle, defineComponent, inferProps, refSetter, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"
import DocumentsFileUpload from "./DocumentsFileUpload"

interface Props {
	cancel(): void
	onUploaded(): void
}

const UploadDocuments: ReactiveComponent<Props> = (props) => {
	const uploadingDocs = shallowRef<File[]>([])
	const handler = useIncidentHandler()
	const popups = usePopups()

	const submitting = ref(false)

	async function handleSubmit(e: Event) {
		e.preventDefault()

		const confirmation = await popups.confirm(() => (
			<Alert title="Confirm File Upload">
				Please confirm that the documents you have selected to upload are correct. You will not be able to delete them
				later.
			</Alert>
		))

		if (!confirmation) {
			return
		}

		submitting.value = true
		try {
			await handler.uploadDocuments(uploadingDocs.value)
			props.onUploaded()
		} catch (e) {
			void showError(e as Error)
		} finally {
			submitting.value = false
		}
	}

	return () => (
		<>
			<ModalTitle title="Upload Documents" />
			<hr />
			<form onSubmit={(e) => void handleSubmit(e)} style={{ display: "contents" }}>
				<DocumentsFileUpload
					class="flex-grow-1"
					files={uploadingDocs.value}
					setFiles={refSetter(uploadingDocs)}
					required
				/>
				<hr />
				<div class="flex justify-end">
					<div class="flex flex-wrap items-center spacing-3">
						<BootstrapButton color="secondary" type="button" onClick={props.cancel} disabled={submitting.value}>
							Cancel
						</BootstrapButton>
						<BootstrapButton
							color="primary"
							type="submit"
							disabled={!uploadingDocs.value.length}
							isSubmitting={submitting.value}
						>
							Upload
						</BootstrapButton>
					</div>
				</div>
			</form>
		</>
	)
}

export default defineComponent(UploadDocuments, inferProps<Props>())
